"use client";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { useState } from "react";
import Next from "../../../public/homePage/next.svg";
import Prev from "../../../public/homePage/prev.svg";
import Link from "next/link";

const QuantisCrousel = (props: any) => {
  const { activeNav, initialScroll } = props;
  const [clickedArrow, setClickedArrow] = useState("");

  const SampleNextArrow = (props: any) => {
    const { className, style, onClick, clickedArrow } = props;

    return (
      <Next
        className={
          className +
          ` productivity-next ${
            clickedArrow === "right" ? "carousel-btn-active" : ""
          }`
        }
        onClick={() => {
          setClickedArrow("right");
          onClick();
        }}
      />
    );
  };

  const SamplePrevArrow = (props: any) => {
    const { className, style, onClick, clickedArrow } = props;
    return (
      <Prev
        className={
          className +
          ` productivity-prev ${
            clickedArrow === "left" ? "carousel-btn-active" : ""
          }`
        }
        onClick={() => {
          setClickedArrow("left");

          onClick();
        }}
      />
    );
  };

  const settings = {
    initialSlide: initialScroll,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          dots: false,
        },
      },
    ],
    nextArrow: <SampleNextArrow clickedArrow={clickedArrow} />,
    prevArrow: <SamplePrevArrow clickedArrow={clickedArrow} />,
  };
  const navLinks = [
    {
      name: "retail",
      label: "Retail",
      url: "/solutions/quantis/retail",
    },
    {
      name: "qsr",
      label: "QSR Franchisee",
      url: "/solutions/quantis/qsr-franchisee",
    },
    {
      name: "fragrance",
      label: "Fragrance industry",
      url: "/solutions/quantis/fragrance-industry",
    },
    {
      name: "optical",
      label: "Optical industry",
      url: "/solutions/quantis/optical-industry",
    },
    {
      name: "fashion",
      label: "Fashion industry",
      url: "/solutions/quantis/fashion-industry",
    },
  ];
  return (
    <Slider {...settings}>
      {navLinks.map((navLink, index) => {
        return (
          <div key={index} className="data-collection-nav px-1">
            <Link
              className={`nav-item ${
                activeNav === navLink.name ? "collection-nav-active" : ""
              }`}
              href={navLink.url}>
              {navLink.label}
            </Link>
          </div>
        );
      })}
    </Slider>
  );
};

export default QuantisCrousel;
